<template>
  <tr>
    <td class="px-4" style="width: 15%">
      <div class="d-flex align-items-center flex-gap-8">
        <!-- Hình ảnh sản phẩm -->
        <ProductImage
          :src="productItem.productImageUrl"
          class="size-40 object-contain flex-shrink-0"
        />

        <!-- Thông tin sản phẩm -->
        <div class="flex-grow-1 min-w-0">
          <p v-if="productItem.barCode" class="m-0 text-medium text-11 lh-1-4">
            {{ productItem.barCode }}
          </p>
          <p v-if="productItem.productCode" class="m-0 text-medium text-12 lh-1-4">
            ({{ productItem.productCode }})
          </p>
          <p class="m-0 font-weight-bolder lh-1-4">
            {{ productItem.name }}
          </p>
        </div>
      </div>
    </td>
    <td class="px-4 text-right" style="width: 5%">
      <span>{{ productItem.totalQuantityInStock }}</span>
    </td>
    <td class="px-4" style="width: 20%">
      <div v-if="editState">
        <b-form-textarea
          :disabled="productItem.productType !== productType.PRODUCT_IMEI"
          style="border-color: #007bff"
          size="sm"
          v-model="productItem.IMEI"
          :placeholder="'IMEI'"
          @keyup="enterClicked()"
          @change="checkValidation"
          class="w-100 h-90"
        ></b-form-textarea>
      </div>
      <div v-else style="white-space: pre">{{ formatImeiList }}</div>
    </td>
    <td class="px-4 text-right" style="width: 10%;t">
      <div v-if="editState">
        <b-form-input
          :disabled="productItem.productType === productType.PRODUCT_IMEI"
          style="height: calc(1.35rem + 1.1rem + 2px); border-color: #007bff"
          v-model="productItem.quantity"
          type="number"
          :min="0"
          placeholder="Số lượng"
          class="w-100 h-90 text-right"
          @change="checkValidation"
        ></b-form-input>
        <b-form-invalid-feedback
          id="input-live-feedback"
          :state="$v.productItem.quantity.minValue"
        >
          Nhập số lượng lớn hơn 0
        </b-form-invalid-feedback>
      </div>
      <span v-else>{{ productItem.quantity }}</span>
    </td>
    <td class="px-4 text-right" style="width: 18%">
      <div v-if="editState">
        <b-form-input
          size="sm"
          style="height: calc(1.35rem + 1.1rem + 2px); border-color: #007bff"
          v-model="productItem.price"
          placeholder="Đơn giá"
          :min="1"
          class="w-100 h-90 text-right"
          @change="checkValidation"
          v-mask="mask"
          :disabled="editPrice"
        ></b-form-input>
        <p style="color: red" v-if="error">Hãy nhập đầy đủ thông tin</p>
      </div>
      <span v-else>{{ convertPrice(productItem.price) }}</span>
    </td>
    <td class="px-4 text-right" style="width: 14%">
      <span>{{ convertPrice(totalPriceOfProduct) }}</span>
    </td>
    <!-- <td class="px-4 text-right" style="width: 13%">
      <div v-if="editState">
        <b-form-input
          size="sm"
          style="height: calc(1.35rem + 1.1rem + 2px); border-color: #007bff"
          v-model="productItem.discount"
          placeholder="Chiết khấu"
          :min="1"
          class="w-100 h-90 text-right"
          @change="checkValidation"
          v-mask="mask"
        ></b-form-input>
        <p style="color: red" v-if="error">Hãy nhập đầy đủ thông tin</p>
      </div>
      <span v-else>{{ convertPrice(productItem.discount) }}</span>
    </td> -->

    <!-- <td style="width: 5%" v-if="editState || deleteState">
      <template>
        <div class="d-flex justify-content-center">
          <v-icon
            small
            class="text-danger"
            @click="showDeleteAlert"
            v-b-tooltip
            title="Xóa"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </td> -->
  </tr>
</template>

<style>
.input {
  border: 1px solid #ecf0f3;
  border-radius: 5px;
  padding-left: 5px;
}

*:focus {
  outline: none;
}
</style>

<script>
import Swal from 'sweetalert2';
import { currencyMask, unMaskPrice, convertPrice } from '@/utils/common';
import { PRODUCT_TYPE } from '@/utils/enum';
import { minValue } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import ProductImage from '@/view/components/products/ProductImage.vue';

export default {
  mixins: [validationMixin],
  components: {
    ProductImage,
  },
  props: {
    productItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    editState: {
      type: Boolean,
      default: false,
    },
    editPrice: {
      type: Boolean,
      default: false,
    },
    deleteState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: true,
      error: false,
      mask: currencyMask,
      productType: PRODUCT_TYPE,
    };
  },
  computed: {
    totalPriceOfProduct() {
      if (this.productItem.name != '') {
        return (
          this.productItem.quantity * unMaskPrice(this.productItem.price) -
          unMaskPrice(this.productItem.discount)
        );
      } else {
        return this.productItem.totalPrice;
      }
    },
    formatImeiList() {
      if (!this.productItem.IMEI) {
        return '';
      }

      const listImei = this.productItem.IMEI.split(/\r\n|\r|\n/);
      const listImeiNo = listImei.map((imei, index) => {
        const no = index + 1;
        return no + ') ' + imei;
      });

      return listImeiNo.join('\r\n');
    },
  },
  validations: {
    productItem: {
      quantity: {
        minValue: minValue(1),
      },
    },
  },
  created() {},
  updated() {
    this.checkAddRow();
  },
  methods: {
    convertPrice,
    checkValidation() {
      this.error = false;
      this.edit = true;
      let dataResponse = this.productItem;
      dataResponse.price = unMaskPrice(this.productItem.price);
      this.$emit('update', dataResponse);
    },
    showDeleteAlert: function() {
      Swal.fire({
        title: 'Xóa sản phẩm!',
        text: 'Bạn có chắc muốn xóa sản phẩm này khỏi phiếu nhập không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
      }).then((result) => {
        if (result.dismiss != 'cancel') {
          this.$emit('deleteItem', this.productItem.id);
        }
      });
    },
    checkAddRow() {
      this.edit = true;
    },
    enterClicked() {
      let countLine = 0;
      const tmp = this.productItem.IMEI.split(/\r\n|\r|\n/);
      tmp.forEach((element) => {
        if (element.trim() !== '') {
          countLine++;
        }
      });
      this.productItem.quantity = countLine;
    },
  },
};
</script>
